// Page dictionary for insights/pv-bess-co-location-sizing.html.
// English is the page's own HTML; main.js merges these over its shared dict.
window.FORSYT_PAGE_I18N = {
  fr: {
    "coloc.hero_eyebrow": "Étude de cas",
    "coloc.hero_title":
      "Colocalisation PV + BESS : des discours aux données",
    "coloc.hero_date":
      'Publié le <time datetime="2026-05-17">17 mai 2026</time>',
    "coloc.hero_subtitle":
      "Une approche fondée sur les données pour dimensionner un BESS adossé à des centrales solaires existantes en France, et arbitrer entre intensité capitalistique et captation des revenus.",
    "coloc.challenge_eyebrow": "L'enjeu",
    "coloc.challenge_p1":
      'Sur le marché solaire, la colocalisation avec des systèmes de stockage par batterie (BESS) est devenue un sujet central. Face à la pression croissante sur les prix captés et à la multiplication des épisodes de prix négatifs, développeurs et investisseurs sont de plus en plus nombreux à <span class="accent">vouloir intégrer du stockage</span> à leurs portefeuilles renouvelables.',
    "coloc.challenge_p2":
      "Pourtant, si le sujet est largement débattu, il reste peu documenté par des études de cas transparentes et étayées par des données. Les investisseurs doivent comprendre non seulement si le modèle fonctionne, mais aussi comment chaque configuration influe sur le business case.",
    "coloc.config_eyebrow": "Choisir la bonne configuration",
    "coloc.config_p1":
      'Menée conjointement par Forsyt Energy et Natural Power, cette étude apporte une réponse concrète en analysant le dimensionnement du BESS pour une <span class="accent">centrale PV existante de 9 MWp</span> en France.',
    "coloc.config_p2":
      'Natural Power a posé les bases techniques, tandis que Forsyt Energy a modélisé les couches marché et valorisation avec <span class="accent">ValuationPro</span>, couvrant :',
    "coloc.config_li1":
      "Le dispatch multi-marchés sur le day-ahead, l'intraday et les services système.",
    "coloc.config_li2":
      "L'empilement des revenus et leur évolution sur la durée de vie de l'actif.",
    "coloc.config_li3":
      "Une modélisation physique de la dégradation et l'analyse des flux de trésorerie nets.",
    "coloc.fig_caption":
      "Décomposition annuelle des revenus (configuration BESS 3 heures)",
    "coloc.results_eyebrow": "Les résultats",
    "coloc.results_p1":
      'L\'étude a comparé plusieurs configurations de BESS. Dans le scénario central, les TRI simplifiés s\'échelonnent de <span class="accent">13,7 % à 14,6 %</span>. Fait notable, la configuration d\'une durée de 3 heures affiche le TRI le plus élevé, en équilibrant captation des revenus et intensité capitalistique.',
    "coloc.results_p2":
      "Enseignement clé : le revenue stack n'est pas figé. Les services système apportent une valeur importante les premières années, tandis que l'arbitrage intraday gagne en importance à mesure que le marché mûrit et que les profils de volatilité évoluent. Le dimensionnement est donc le levier décisif de ce business case.",
    "coloc.download_title": "Télécharger l'étude complète",
    "coloc.download_text":
      "Accédez à l'intégralité de l'étude de cas conjointe de Forsyt Energy et Natural Power, avec le détail des hypothèses techniques, la ventilation des revenus et l'analyse de sensibilité du TRI.",
    "coloc.download_btn": "Télécharger l'étude complète (PDF)",
    "coloc.rel1_eyebrow": "Réglementation",
    "coloc.rel1_title":
      "Ce que change le relèvement du seuil de raccordement HTA pour le PV + BESS",
    "coloc.rel1_text":
      "Le relèvement du plafond HTA élargit le nombre de projets hybrides pouvant éviter un raccordement au réseau de transport, et modifie la manière de dimensionner le raccordement.",
    "coloc.rel_link": "Lire l'analyse complète →",
    "coloc.rel2_eyebrow": "Signaux de marché",
    "coloc.rel2_title": "Le danger des planchers de prix négatifs",
    "coloc.rel2_text":
      "Pourquoi des prix day-ahead à -500 €/MWh signalent un marché qui perd sa capacité de formation des prix.",
    "coloc.view_all": "Voir toutes les analyses",
    "coloc.cta_eyebrow": "RESTONS EN CONTACT",
    "coloc.cta_text":
      "Dites-nous de quelles analyses vous avez besoin ou ce que vous aimeriez voir dans nos benchmarks.",
    "coloc.cta_btn": "Prendre rendez-vous",
    "coloc.cta_note":
      'Ou écrivez-nous à <a href="mailto:contact@forsytenergy.com">contact@forsytenergy.com</a>, nous vous répondrons rapidement.',
  },
  de: {
    "coloc.hero_eyebrow": "Fallstudie",
    "coloc.hero_title": "Co-Location von PV + BESS: vom Diskurs zu Daten",
    "coloc.hero_date":
      'Veröffentlicht am <time datetime="2026-05-17">17. Mai 2026</time>',
    "coloc.hero_subtitle":
      "Ein datenbasierter Ansatz zur BESS-Dimensionierung für bestehende Solaranlagen in Frankreich, der die Zielkonflikte zwischen Kapitalintensität und Erlöserschließung beleuchtet.",
    "coloc.challenge_eyebrow": "Die Herausforderung",
    "coloc.challenge_p1":
      'Im Solarmarkt ist die Co-Location mit Batteriespeichern (BESS) zu einem zentralen Thema geworden. Da der Druck auf die erzielten Preise wächst und negative Preise immer häufiger auftreten, <span class="accent">wollen immer mehr Entwickler und Investoren Speicher</span> in ihre Erneuerbaren-Portfolios integrieren.',
    "coloc.challenge_p2":
      "Doch obwohl das Konzept breit diskutiert wird, gibt es kaum transparente, datengestützte Fallstudien dazu. Investoren müssen nicht nur verstehen, ob es funktioniert, sondern auch, wie sich unterschiedliche Konfigurationen auf den Investment Case auswirken.",
    "coloc.config_eyebrow": "Die richtige Konfiguration wählen",
    "coloc.config_p1":
      'Diese gemeinsam von Forsyt Energy und Natural Power durchgeführte Studie liefert eine konkrete Antwort: Sie analysiert die BESS-Dimensionierung für eine <span class="accent">bestehende 9-MWp-PV-Anlage</span> in Frankreich.',
    "coloc.config_p2":
      'Natural Power legte die technischen Grundlagen, Forsyt Energy modellierte mit <span class="accent">ValuationPro</span> die Markt- und Bewertungsebene, darunter:',
    "coloc.config_li1":
      "Marktübergreifender Dispatch über Day-Ahead, Intraday und Systemdienstleistungen.",
    "coloc.config_li2":
      "Erlös-Stacking und dessen Entwicklung über die Lebensdauer der Anlage.",
    "coloc.config_li3":
      "Physikbasierte Degradationsmodellierung und Analyse der Netto-Cashflows.",
    "coloc.fig_caption":
      "Jährliche Erlösaufschlüsselung (BESS-Konfiguration mit 3 Stunden)",
    "coloc.results_eyebrow": "Die Ergebnisse",
    "coloc.results_p1":
      'Die Studie verglich mehrere BESS-Konfigurationen. Im zentralen Szenario lagen die vereinfachten IRRs zwischen <span class="accent">13,7 % und 14,6 %</span>. Bemerkenswert: Die Konfiguration mit 3 Stunden Speicherdauer erzielte die höchste IRR, da sie Erlöserschließung und Kapitalintensität am besten ausbalanciert.',
    "coloc.results_p2":
      "Eine zentrale Erkenntnis: Der Revenue Stack ist nicht statisch. Systemdienstleistungen liefern in den ersten Jahren erhebliche Erlöse, während die Intraday-Arbitrage an Bedeutung gewinnt, je reifer der Markt wird und je stärker sich die Volatilitätsmuster verschieben. Die Dimensionierung ist daher der entscheidende Hebel dieses Investment Case.",
    "coloc.download_title": "Vollständige Studie herunterladen",
    "coloc.download_text":
      "Erhalten Sie die vollständige gemeinsame Fallstudie von Forsyt Energy und Natural Power, inklusive detaillierter technischer Annahmen, Erlösaufschlüsselungen und IRR-Sensitivitätsanalyse.",
    "coloc.download_btn": "Vollständige Studie herunterladen (PDF)",
    "coloc.rel1_eyebrow": "Regulierung",
    "coloc.rel1_title":
      "Was eine höhere HTA-Anschlussschwelle für PV + BESS bedeutet",
    "coloc.rel1_text":
      "Eine höhere HTA-Obergrenze erweitert den Kreis hybrider Projekte, die ohne Anschluss an das Übertragungsnetz auskommen, und verändert die Dimensionierung des Netzanschlusses.",
    "coloc.rel_link": "Vollständige Analyse lesen →",
    "coloc.rel2_eyebrow": "Marktsignale",
    "coloc.rel2_title": "Die Gefahr negativer Preisuntergrenzen",
    "coloc.rel2_text":
      "Warum Day-Ahead-Preise von -500 €/MWh auf einen Markt hindeuten, dem der Spielraum für die Preisfindung verloren geht.",
    "coloc.view_all": "Alle Insights ansehen",
    "coloc.cta_eyebrow": "IN KONTAKT BLEIBEN",
    "coloc.cta_text":
      "Sagen Sie uns, welche Analysen Sie benötigen oder was Sie in unseren Benchmarks sehen möchten.",
    "coloc.cta_btn": "Termin vereinbaren",
    "coloc.cta_note":
      'Oder schreiben Sie uns an <a href="mailto:contact@forsytenergy.com">contact@forsytenergy.com</a> – wir melden uns umgehend bei Ihnen.',
  },
};
